import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const DocumentLayoutPane = styled(Box, { label: 'DocumentLayoutPane' })(() => ({
  display: 'flex',
  overflow: 'hidden',
  flex: 1,
  flexDirection: 'column',
}));
